import React, { Component } from 'react'
import { Row, Button, Col, Card, List, Icon, Popconfirm, Modal, Popover } from 'antd'
import { Redirect } from 'react-router-dom'
import { api, app, config } from '../../app'
import underscore from 'underscore'
import '../../css/mall.css'
import common from './common'

const order_state = common.order_state

class MOrderDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            orders_id: '',
            data_loading: true,
            order_info: {},
        }
    }

    componentDidMount() {
        this._isMounted = true
        const orders_id = this.props.match.params.id
        this.setState({ orders_id }, () => {
            this.DataList(orders_id)
        })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 提醒
     */
    handleRemind = () => {
        Modal.success({
            title: '温馨提示',
            content: '提醒成功',
            centered: true
        })
    }

    checkOrderBtn(type) {
        const { action_loading, order_info } = this.state
        switch (type) {
            case '0':
                return (<Button type="primary" onClick={() => this.handlePay(order_info.out_trade_no)}>去支付</Button>)
            case '5':
                return (<Button type="primary" onClick={() => this.handleRemind()}>提醒发货</Button>)
            case '3':
                return (<Button type="primary" loading={action_loading}
                    onClick={() => this.handleConfirmOrder()}>确认收货</Button>)
            case '9':
                return null
            default:
                return null
        }
    }

    /**
     * 支付
     * @param orders_no
     * @returns {Promise<boolean>}
     */
    handlePay = async (orders_no) => {
        await common.pay2(orders_no)
    }

    /**
     * 取消
     * @param orders_no
     * @returns {Promise<boolean>}
     */
    handleCancel = async () => {
        const { orders_id } = this.state
        await common.cancel(orders_id)
        app.alert('取消成功', 'success')
        this.setState({ page: 1 }, () => {
            this.DataList(orders_id)
        })
    }

    /**
     * 确认收货
     * @returns {boolean}
     */
    handleConfirmOrder = () => {
        if (this.state.action_loading) return false
        this.setState({ action_loading: true }, () => {
            const _this = this, { orders_id } = this.state, params = {
                orders_id: orders_id,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }
            app.post(api.MyOrdersConfirmReceipt, params).then(({ flag, data, msg }) => {
                if (_this._isMounted) {
                    if (flag === 1) {
                        app.alert('确认成功', 'success')
                        _this.setState({ action_loading: false }, () => {
                            _this.DataList(orders_id)
                        })
                    } else {
                        app.alert(msg, 'warn')
                    }
                }
            })
        })
    }

    /**
     * 数据
     * @param orders_id
     * @constructor
     */
    DataList = (orders_id) => {
        const _this = this, params = {
            orders_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        app.post(api.MyOrdersDetails, params).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    _this.setState({ data_loading: false, order_info: data })
                } else {
                    app.alert(msg, 'warn')
                }
            }
        })
    }

    render() {
        const isLogin = app.checkLogin()
        if (isLogin) {
            return (<Redirect to="/" />)
        } else {
            const { order_info, data_loading, action_loading } = this.state
            let state = {}
            if (order_info.is_cancel === '0') {
                if (order_info.gstatus === '0' && order_info.trade_status === 'TRADE_SUCCESS') {
                    state.name = '已付款'
                } else {
                    state = underscore.find(order_state, (s) => s.id === order_info.gstatus) || { name: '未知' }
                }
            } else if (order_info.is_cancel === '1') {
                state.name = '已取消'
            }
            let pay_method_text = ''
            switch (order_info.pay_method + '') {
                case '1':
                    pay_method_text = '（支付宝）'
                    break
                case '2':
                    pay_method_text = '（微信）'
                    break
                case '3':
                    pay_method_text = '（支付宝）'
                    break
                case '4':
                    pay_method_text = '（微信）'
                    break
            }
            return (
                <div className="mall-order-detail">
                    <div className="detail1">
                        <div style={{ marginBottom: 15 }}>
                            <Button onClick={() => this.props.history.go(-1)}>返回</Button>
                        </div>
                        <Row type="flex">
                            <h1 className="title flex-eq">
                                订单号：{order_info.out_trade_no}
                                {pay_method_text}
                            </h1>
                            {/*<div className="action-btn flex-eq">*/}
                            {/*<Button.Group>*/}
                            {/*<Button type="primary">无法生产</Button>*/}
                            {/*<Button type="primary">重复订单</Button>*/}
                            {/*<Button type="primary">不生产</Button>*/}
                            {/*<Button type="primary">重新处理</Button>*/}
                            {/*<Button type="primary">发货</Button>*/}
                            {/*</Button.Group>*/}
                            {/*</div>*/}
                        </Row>
                        <Row type="flex">
                            <div className="flex-eq order-info">
                                <Row gutter={40}>
                                    <Col span={24}>
                                        <div className="term-l">收货信息</div>
                                        <div className="term-r">
                                            {order_info.receiver_name ? order_info.receiver_name + ',' : ''}
                                            {order_info.receiver_phone ? order_info.receiver_phone + ',' : ''}
                                            {order_info.receiver_address ? order_info.receiver_address : ''}
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={40}>
                                    {/* <Col span={12}>
                                        <div className="term-l">收货人</div>
                                        <div className="term-r">{order_info.receiver_name}</div>
                                    </Col> */}
                                    <Col span={12}>
                                        <div className="term-l">创建时间</div>
                                        <div className="term-r">{order_info.datetime}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">管理员审核</div>
                                        {/* <div className="term-r">{order_info.team_header_name}</div> */}
                                        <div className="term-r">{order_info.admin_name}</div>
                                    </Col>

                                    {/* <Col span={12}>
                                        <div className="term-l">联系方式</div>
                                        <div className="term-r">{order_info.receiver_phone}</div>
                                    </Col> */}
                                </Row>
                                <Row gutter={40}>
                                    {/* <Col span={12}>
                                        <div className="term-l">收货地址</div>
                                        <div className="term-r">{order_info.receiver_address || '暂无'}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">支付时间</div>
                                        <div className="term-r">{order_info.send_pay_date || '暂无'}</div>
                                    </Col> */}
                                    <Col span={12}>
                                        <div className="term-l">支付时间</div>
                                        <div className="term-r">{order_info.send_pay_date || "暂无"}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">管理员审核时间</div>
                                        {/* <div className="term-r">{order_info.team_header_time || "暂无"}</div> */}
                                        <div className="term-r">{order_info.admin_time || "暂无"}</div>
                                    </Col>
                                </Row>
                                <Row gutter={40}>
                                    {/* <Col span={12}>
                                        <div className="term-l">快递公司</div>
                                        <div className="term-r">{order_info.courier_company || '暂无'}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">快递单号</div>
                                        <div className="term-r">{order_info.courier_number || '暂无'}</div>
                                    </Col> */}
                                    <Col span={12}>
                                        <div className="term-l">发货时间</div>
                                        <div className="term-r">{order_info.delivery_time || "暂无"}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">管理员审核状态</div>
                                        <div
                                            className="term-r">
                                            {order_info.admin_is_onfirm === "true" ? "已通过" : (order_info.detail ? "不通过" : "未审核")}
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">快递公司</div>
                                        <div className="term-r">{order_info.courier_company || "暂无"}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">异常原因</div>
                                        <div className="term-r">{order_info.detail || '无'}</div>
                                    </Col>
                                    {/* <Col span={12}>
                                        <div className="term-l">省级/超管审核</div>
                                        <div
                                            className="term-r">{order_info.admin_name || "暂无"}</div>
                                    </Col> */}
                                </Row>
                                <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">快递单号</div>
                                        <div className="term-r">{order_info.courier_number || "暂无"}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">备注</div>
                                        <div className="term-r">{order_info.remark || '无'}</div>
                                    </Col>
                                    {/* <Col span={12}>
                                        <div className="term-l">省级/超管审核时间</div>
                                        <div className="term-r">{order_info.admin_time || "暂无"}</div>
                                    </Col> */}
                                </Row>
                                <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">买家留言</div>
                                        <div className="term-r">{order_info.buy_message || '无'}</div>
                                    </Col>
                                    {/* <Col span={12}>
                                        <div className="term-l">省级/超管审核状态</div>
                                        <div
                                            className="term-r">{order_info.admin_is_onfirm === "true" ? "已通过" : (order_info.detail ? "不通过" : "未审核")}</div>
                                    </Col> */}
                                </Row>
                                <Row gutter={40}>
                                    {/* <Col span={24}>
                                        <div className="term-l">异常原因</div>
                                        <div className="term-r">{order_info.detail || '无'}</div>
                                    </Col> */}
                                    {/* <Col span={24}>
                                        <div className="term-l">备注</div>
                                        <div className="term-r">{order_info.remark || '无'}</div>
                                    </Col> */}
                                </Row>
                                {/* <Row gutter={40}>
                                    
                                </Row> */}
                                {/* <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">创建时间</div>
                                        <div className="term-r">{order_info.datetime}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">发货时间</div>
                                        <div className="term-r">{order_info.delivery_time || '暂无'}</div>
                                    </Col>
                                </Row>
                                <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">队管理员姓名</div>
                                        <div
                                            className="term-r">{order_info.team_header_name || '暂无'}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">省级/超级管理员姓名</div>
                                        <div
                                            className="term-r">{order_info.admin_name || '暂无'}</div>
                                    </Col>
                                </Row>
                                <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">队管理员审核时间</div>
                                        <div
                                            className="term-r">{order_info.team_header_time || '暂无'}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">省级/超级管理员审核时间</div>
                                        <div className="term-r">{order_info.admin_time || '暂无'}</div>
                                    </Col>
                                </Row>
                                <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">队管理员审核状态</div>
                                        <div
                                            className="term-r">{order_info.team_header_is_confirm === 'true' ? '已通过' : (order_info.detail ? '不通过' : '未审核')}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">省级/超级管理员审核状态</div>
                                        <div
                                            className="term-r">{order_info.admin_is_onfirm === 'true' ? '已通过' : (order_info.detail ? '不通过' : '未审核')}</div>
                                    </Col>
                                </Row>
                                <Row gutter={40}>
                                    <Col span={12}>
                                        <div className="term-l">异常原因</div>
                                        <div className="term-r">{order_info.detail || '无'}</div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-l">买家留言</div>
                                        <div className="term-r">{order_info.buy_message || '无'}</div>
                                    </Col>
                                </Row> */}
                            </div>
                            <div className="flex-eq sta-pri">
                                <Row>
                                    <Col span={12}>
                                        <div className="term-t" style={{ paddingRight: 25 }}>订单状态</div>
                                        <div className="term-b">
                                            <Popover content={order_info.gstatus_remark || ' - '} title={<div style={{ textAlign: 'center' }}>状态说明</div>}>
                                                <Icon style={{ color: 'red', cursor: 'pointer' }} type="info-circle" />
                                            </Popover>
                                            <span style={{ marginLeft: 10 }}>{state.name}</span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="term-t">订单总金额</div>
                                        <div className="term-b">￥{order_info.total_amount}</div>
                                    </Col>
                                </Row>
                            </div>
                        </Row>
                    </div>
                    <div className="detail2">
                        <Card title={'商品信息'} extra={`共${(order_info.mall_info || []).length}件`} bordered={false}>
                            <List
                                bordered={true}
                                itemLayout="horizontal"
                                dataSource={order_info.mall_info || []}
                                renderItem={item => (
                                    <List.Item>
                                        <List.Item.Meta
                                            avatar={<div className="good-img"><img
                                                src={config.imgUrl + item.localpath} />
                                            </div>}
                                            title={item.ppename}
                                            description={
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        minHeight: '92px',
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <div>
                                                        <span style={{ padding: '2px 4px', background: item.custom_name == '' || item.custom_name == null ? '' : '#f2f2f2', borderRadius: '4px', display: 'inline-block' }}>
                                                            {item.details_huopin_content + (item.custom_name ? `（${item.custom_name}）` : '')}
                                                        </span>
                                                    </div>
                                                    {/* <div className="gc-2"
                                                        hidden={['3', '4'].indexOf(item.details_mall_id) === -1}>
                                                        <span>本批统计数量/生产数量 {item.buyNumber} / {item.produce_number}</span></div> */}
                                                </div>
                                            }
                                        />
                                        <div className="good-count" style={{ textAlign: 'right' }}>
                                            <div style={{ fontSize: '14px' }}>
                                                ￥ {item.details_money}
                                            </div>
                                            <div className="gc-1"><Icon type="close" /> {item.details_nums}</div>
                                            <div style={{ fontSize: '14px' }}>
                                                小计：￥ {item.amount}
                                            </div>
                                            {/* <div className="gc-2"
                                                 hidden={['3', '4'].indexOf(item.details_mall_id) === -1}>
                                                <span>本批统计数量/生产数量 {item.buyNumber} / {item.produce_number}</span></div> */}
                                        </div>
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </div>
                    {(order_info.gstatus === '0' && order_info.trade_status === 'TRADE_SUCCESS') ? null :
                        <div className="detail3">
                            {
                                order_info.gstatus === '0' && order_info.is_cancel === '0' ?
                                    <Popconfirm title="是否取消订单！" onConfirm={() => this.handleCancel()}
                                        okText="是" cancelText="否">
                                        <Button>取消订单</Button>
                                    </Popconfirm>
                                    : null
                            }
                            {
                                order_info.is_cancel === '1' ? '已取消' : this.checkOrderBtn(order_info.gstatus)
                            }
                        </div>
                    }
                </div>
            )
        }
    }
}

export default MOrderDetail



// WEBPACK FOOTER //
// ./src/routes/mall/MOrderDetail.jsx